import { render, staticRenderFns } from "./examinationVisualAcuityHome.vue?vue&type=template&id=f8ee462e&scoped=true&"
import script from "./examinationVisualAcuityHome.vue?vue&type=script&lang=js&"
export * from "./examinationVisualAcuityHome.vue?vue&type=script&lang=js&"
import style0 from "./examinationVisualAcuityHome.vue?vue&type=style&index=0&id=f8ee462e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ee462e",
  null
  
)

export default component.exports